var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12A12 12 0 0016 4zm6 5.813a2.25 2.25 0 012.25 2.25v3.374a2.25 2.25 0 01-2.25 2.25h-2.786l-.18.844a.488.488 0 01-.454.375h-.563a.294.294 0 01-.295-.375l.18-.843h-1.313l-.18.843a.488.488 0 01-.454.375h-.563a.294.294 0 01-.295-.375l.18-.843H13.87L12.634 23.5h-3l2.192-10.313h3l-.478 2.25h5.777c.621 0 1.125-.503 1.125-1.124v-1.126c0-.62-.504-1.124-1.125-1.124H7.75l1.875-2.25h7.326l.179-.844a.488.488 0 01.454-.375h.563a.294.294 0 01.295.375l-.179.844h1.313l.179-.844a.488.488 0 01.454-.375h.563a.294.294 0 01.295.375l-.179.844H22z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasc);
export default __webpack_public_path__ + "static/media/pasc.e03edb7b0e74552dcfce48e09a5067dc.svg";
export { ForwardRef as ReactComponent };